import React, { useRef } from 'react';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useReactToPrint } from 'react-to-print';
import { FiPrinter } from 'react-icons/fi';

import PrintRequestHeader from './PrintRequestHeader';
import PrintRequestUserInfo from './PrintRequestUserInfo';
import PrintRequestProductList from './PrintRequestProductList';
import useStyles from './styles';
import { formatMoney } from 'helpers/moneyFormatter';

export default function PrintRequest({ request }) {
  const componentRef = useRef();
  const classes = useStyles();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Button fullWidth startIcon={<FiPrinter />} onClick={handlePrint}>
        Imprimir
      </Button>

      <div style={{ display: 'none' }}>
        <div ref={componentRef} className={classes.container}>
          {!!request && (
            <>
              <PrintRequestHeader request={request} />

              {request.table ? (
                <>
                  <b>Mesa:</b>
                  {` ${request.table.number}`}
                </>
              ) : (
                <b>Entrega</b>
              )}

              <PrintRequestUserInfo
                user={request.user}
                requestTypeId={request.request_type_id}
              />

              <Divider />

              <PrintRequestProductList
                requestProducts={request.request_products}
              />

              <Box className={classes.total}>
                <Typography>
                  <b>{`Total do Pedido: ${formatMoney(request.total_price)}`}</b>
                </Typography>
              </Box>
            </>
          )}
        </div>
      </div>
    </>
  );
}
